import React from "react";
import { Box } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";

interface ChatModeSwitchProps {
  showVoicePanel: boolean;
  onClickText: () => void;
  onClickVoice: () => void;
}

const ChatModeSwitch: React.FC<ChatModeSwitchProps> = ({
  showVoicePanel,
  onClickText,
  onClickVoice,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        width: { xs: "92%", sm: "80%", md: "60%" },
        maxWidth: 720,
        borderRadius: 9999,
        overflow: "visible",
        bgcolor: "#eef2f7",
        p: 0.5,
        gap: 0.5,
      }}
    >
      <Box
        onClick={onClickText}
        sx={{
          flex: 1,
          cursor: "pointer",
          px: { xs: 2, md: 2.5 },
          py: { xs: 1, md: 1.25 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.5,
          fontWeight: 700,
          color: "#111827",
          bgcolor: !showVoicePanel ? "#ffffff" : "transparent",
          borderRadius: 9999,
          boxShadow: !showVoicePanel ? "0 4px 10px rgba(0,0,0,0.08)" : "none",
          userSelect: "none",
          transition: "all .15s ease",
          '&:hover': { bgcolor: !showVoicePanel ? "#ffffff" : "#e7edf5" },
        }}
      >
        <ChatIcon sx={{ fontSize: { xs: 16, md: 18 } }} />
        Text Chat
      </Box>
      <Box
        onClick={onClickVoice}
        sx={{
          flex: 1,
          cursor: "pointer",
          px: { xs: 2, md: 2.5 },
          py: { xs: 1, md: 1.25 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.5,
          fontWeight: 700,
          color: "#111827",
          bgcolor: showVoicePanel ? "#ffffff" : "transparent",
          borderRadius: 9999,
          boxShadow: showVoicePanel ? "0 4px 10px rgba(0,0,0,0.08)" : "none",
          userSelect: "none",
          transition: "all .15s ease",
          '&:hover': { bgcolor: showVoicePanel ? "#ffffff" : "#e7edf5" },
        }}
      >
        <GraphicEqIcon sx={{ fontSize: { xs: 16, md: 18 } }} />
        Voice Chat
      </Box>
    </Box>
  );
};

export default ChatModeSwitch;


